<template>
  <div class="chart-container">
    <div class="chart-title">中心区域项目数量统计</div>
    <div id="barChart" style="width: 100%; height: calc(100% - 30px)"></div>

    <div v-if="dialogVisible" class="modal-overlay" @click="closeDialog">
      <div class="modal-content is-detail-modal" @click.stop>
        <div class="modal-header">
          <h3>{{ dialogTitle }}</h3>
          <span class="close-btn" @click="closeDialog">&times;</span>
        </div>

        <div class="modal-body">
          <div class="search-panel">
            <div class="search-grid">
              <div class="search-item">
                <label>小区名称</label>
                <input
                  v-model="searchForm.communityName"
                  type="text"
                  class="search-input"
                  placeholder="请输入小区名称"
                />
              </div>
              <div class="search-item">
                <label>检验机构</label>
                <input
                  v-model="searchForm.inspection_organization"
                  type="text"
                  class="search-input"
                  placeholder="请输入检验机构"
                />
              </div>
              <div class="search-item">
                <label>设备代码</label>
                <input
                  v-model="searchForm.device_code"
                  type="text"
                  class="search-input"
                  placeholder="请输入设备代码"
                />
              </div>
              <div class="search-item">
                <label>年审时间</label>
                <input
                  v-model="searchForm.audittimes"
                  type="text"
                  class="search-input"
                  placeholder="请输入年审时间"
                />
              </div>
              <div class="search-item">
                <label>使用登记号</label>
                <input
                  v-model="searchForm.elevator_sign"
                  type="text"
                  class="search-input"
                  placeholder="请输入使用登记号"
                />
              </div>
              <div class="search-item">
                <label>电梯工号</label>
                <input
                  v-model="searchForm.elevator_number"
                  type="text"
                  class="search-input"
                  placeholder="请输入电梯工号"
                />
              </div>
              <div class="search-item">
                <label>维保单位</label>
                <input
                  v-model="searchForm.wb_record_unit_name"
                  type="text"
                  class="search-input"
                  placeholder="请输入维保单位"
                />
              </div>
            </div>
            <div class="search-actions">
              <button class="action-btn primary" @click="handleSearch">搜索</button>
              <button class="action-btn" @click="handleReset">重置</button>
            </div>
          </div>

          <div class="data-table detail-table">
            <div class="table-header detail-header">
              <div class="header-item col-name">小区名称</div>
              <div class="header-item col-number">电梯工号</div>
              <div class="header-item col-code">设备代码</div>
              <div class="header-item col-sign">使用登记号</div>
              <div class="header-item col-unit">维保单位</div>
              <div class="header-item col-org">检验机构</div>
              <div class="header-item col-audit">年审时间</div>
            </div>
            <div class="table-body detail-body">
              <div v-if="tableLoading" class="empty-tip">加载中...</div>
              <template v-else>
                <div
                  v-for="(item, index) in tableData"
                  :key="`project-${index}`"
                  class="table-row detail-row"
                >
                  <div class="table-cell col-name text-left">{{ item.name || '-' }}</div>
                  <div class="table-cell col-number">{{ item.elevator_number || '-' }}</div>
                  <div class="table-cell col-code text-left">{{ item.device_code || '-' }}</div>
                  <div class="table-cell col-sign">{{ item.elevator_sign || '-' }}</div>
                  <div class="table-cell col-unit text-left">{{ item.wb_record_unit_name || '-' }}</div>
                  <div class="table-cell col-org text-left">{{ item.inspection_organization || '-' }}</div>
                  <div class="table-cell col-audit">{{ item.audittimes || '-' }}</div>
                </div>
                <div v-if="!tableData.length" class="empty-tip">暂无数据</div>
              </template>
            </div>
          </div>

          <div v-if="pagination.total" class="pagination-bar">
            <button
              class="page-btn"
              :disabled="pagination.currentPage <= 1"
              @click="handleCurrentChange(pagination.currentPage - 1)"
            >
              上一页
            </button>
            <span class="page-info">
              第 {{ pagination.currentPage }} / {{ totalPages }} 页，共 {{ pagination.total }} 条
            </span>
            <select v-model.number="pagination.pageSize" class="page-size-select" @change="handleSizeChange(pagination.pageSize)">
              <option :value="10">10条/页</option>
              <option :value="20">20条/页</option>
              <option :value="50">50条/页</option>
              <option :value="100">100条/页</option>
            </select>
            <button
              class="page-btn"
              :disabled="pagination.currentPage >= totalPages"
              @click="handleCurrentChange(pagination.currentPage + 1)"
            >
              下一页
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { dashboardAPI } from "@/api/dashboard";

export default {
  name: "ProjectStatisticsBarChart",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartInstance: null,
      dialogVisible: false,
      selectedItem: null,
      tableData: [],
      tableLoading: false,
      searchForm: {
        communityName: "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
        wb_record_unit_name: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  computed: {
    dialogTitle() {
      const category = this.selectedItem ? this.selectedItem.name : "";
      return category ? `${category} - 详细数据（${this.pagination.total}条）` : "详细数据";
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.pagination.total / this.pagination.pageSize));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.updateChart();
    });
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.off("click", this.handleBarClick);
      this.chartInstance.dispose();
    }
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById("barChart");
      if (!chartDom) return;

      this.chartInstance = echarts.init(chartDom);
      this.chartInstance.on("click", this.handleBarClick);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    updateChart() {
      if (!this.chartInstance || !this.chartData.length) return;

      const maxValue = Math.max(...this.chartData.map((item) => item.value), 100);
      const yAxisMax = Math.ceil(maxValue / 20) * 20 + 20;

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "30px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.chartData.map((item) => item.name),
          axisTick: { alignWithLabel: true },
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        yAxis: {
          type: "value",
          name: "数量",
          min: 0,
          max: yAxisMax,
          interval: 20,
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(0, 212, 255, 0.2)" } },
        },
        series: [
          {
            data: this.chartData.map((item) => item.value),
            type: "bar",
            barWidth: "50%",
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              fontSize: 12,
              fontWeight: "bold",
              formatter: "{c}",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00d4ff" },
                { offset: 1, color: "#0088cc" },
              ]),
              borderRadius: [4, 4, 0, 0],
            },
          },
        ],
      };
      this.chartInstance.setOption(option);
    },
    handleBarClick(params) {
      this.selectedItem = this.chartData[params.dataIndex];
      this.dialogVisible = true;
      this.pagination.currentPage = 1;
      this.searchForm = {
        communityName: this.selectedItem.name || "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
        wb_record_unit_name: "",
      };
      this.loadTableData();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.selectedItem = null;
      this.tableData = [];
      this.pagination.total = 0;
    },
    async loadTableData() {
      this.tableLoading = true;
      try {
        const response = await dashboardAPI.getProjectListByRegion(this.searchForm);

        if (response.code === 1) {
          const allData = response.data || [];
          this.pagination.total = allData.length;

          const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
          const end = start + this.pagination.pageSize;
          this.tableData = allData.slice(start, end);
        } else {
          this.tableData = [];
          this.pagination.total = 0;
          this.$message.error(response.msg || "获取数据失败");
        }
      } catch (error) {
        console.error("加载表格数据失败:", error);
        this.tableData = [];
        this.pagination.total = 0;
        this.$message.error("加载数据失败");
      } finally {
        this.tableLoading = false;
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.loadTableData();
    },
    handleReset() {
      this.searchForm = {
        communityName: this.selectedItem ? this.selectedItem.name || "" : "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
        wb_record_unit_name: "",
      };
      this.pagination.currentPage = 1;
      this.loadTableData();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = Number(val) || 20;
      this.pagination.currentPage = 1;
      this.loadTableData();
    },
    handleCurrentChange(page) {
      if (page < 1 || page > this.totalPages) return;
      this.pagination.currentPage = page;
      this.loadTableData();
    },
  },
};
</script>

<style scoped lang="less">
.chart-container {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  flex: 1;
  min-height: 120px;
  position: relative;
  overflow: hidden;
}

.chart-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.chart-title {
  font-size: 16px;
  margin: 10px 0;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  width: 98%;
  max-width: 1680px;
  max-height: 94vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #0a1929 0%, #1a2332 50%, #0e2a42 100%);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(0, 212, 255, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);

  h3 {
    margin: 0;
    color: #00d4ff;
    font-size: 18px;
  }
}

.close-btn {
  color: #00d4ff;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #ff3366;
  }
}

.modal-body {
  padding: 16px 20px 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.search-panel {
  margin-bottom: 14px;
  padding: 14px;
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 8px;
  background: rgba(0, 212, 255, 0.04);
}

.search-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 16px;
}

.search-item {
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    color: #88c4ff;
    font-size: 12px;
    font-weight: bold;
  }
}

.search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  background: rgba(0, 212, 255, 0.08);
  border: 1px solid rgba(0, 212, 255, 0.35);
  border-radius: 6px;
  color: #e8f4ff;
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: #88c4ff;
  }

  &:focus {
    border-color: rgba(0, 212, 255, 0.6);
    box-shadow: 0 0 8px rgba(0, 212, 255, 0.15);
  }
}

.search-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px;
}

.action-btn {
  padding: 6px 16px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.4);
  border-radius: 6px;
  color: #88c4ff;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 212, 255, 0.18);
    color: #00d4ff;
  }

  &.primary {
    color: #00d4ff;
    border-color: rgba(0, 212, 255, 0.55);
    background: rgba(0, 212, 255, 0.16);
  }
}

.data-table {
  border: 1px solid rgba(0, 212, 255, 0.25);
  border-radius: 8px;
  overflow: hidden;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.detail-header,
.detail-row {
  display: grid;
  grid-template-columns:
    minmax(180px, 2fr)
    minmax(100px, 1fr)
    minmax(180px, 1.6fr)
    minmax(120px, 1fr)
    minmax(160px, 1.6fr)
    minmax(180px, 1.8fr)
    minmax(90px, 0.8fr);
  align-items: stretch;
}

.detail-body {
  flex: 1;
  min-height: 0;
  max-height: calc(94vh - 320px);
  overflow: auto;
}

.detail-row {
  min-height: 52px;
}

.header-item,
.table-cell {
  padding: 10px 12px;
  font-size: 13px;
  text-align: center;
  word-break: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-header {
  background: rgba(0, 212, 255, 0.12);
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
}

.header-item {
  color: #00d4ff;
  font-weight: bold;
}

.table-row {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  &:hover {
    background: rgba(0, 212, 255, 0.06);
  }
}

.table-cell {
  color: #fff;
}

.text-left {
  justify-content: flex-start;
  text-align: left;
  line-height: 1.5;
}

.empty-tip {
  padding: 28px;
  text-align: center;
  color: #88c4ff;
  font-size: 14px;
}

.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.page-btn {
  padding: 6px 14px;
  background: rgba(0, 212, 255, 0.12);
  border: 1px solid rgba(0, 212, 255, 0.4);
  border-radius: 6px;
  color: #00d4ff;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: rgba(0, 212, 255, 0.2);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.page-info {
  color: #88c4ff;
  font-size: 13px;
}

.page-size-select {
  padding: 5px 10px;
  background: rgba(0, 212, 255, 0.08);
  border: 1px solid rgba(0, 212, 255, 0.35);
  border-radius: 6px;
  color: #e8f4ff;
  outline: none;
}

@media (max-width: 1200px) {
  .search-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
